import StepWrapper from "./StepWrapper";
import { Form } from "react-bootstrap";

const AdjustmentBalanceStep = ({ data, onSubmit, totalSteps }) => (
  <StepWrapper
    step={data.step}
    total={totalSteps}
    onPrev={() => onSubmit({ step: data.step - 1 })}
    onNext={() => onSubmit({ step: data.step + 1 })}
  >
    <Form.Group>
      <Form.Label>Amount to be added to user balance due</Form.Label>
      <Form.Control
        type="number"
        placeholder="Adjustment Amount"
        value={data?.totalAmount || ""}
        onChange={(e) =>
          onSubmit({
            totalAmount: e.target.value,
            totalAmountDetails: { cashAmount: 0, onlineAmount: e.target.value },
          })
        }
        required
        step="0.01"
        autoFocus
      />
    </Form.Group>
  </StepWrapper>
);

export default AdjustmentBalanceStep;
